import React from "react";
import { bool, func, string } from "prop-types";
import { connect } from "react-redux";
import { dismissErrorModal } from "../../redux/actions";
import Modal from "../../common/Modal";
import { WithBackground } from "../../common";

const ErrorModal = ({
  isDismissable,
  displayModal,
  dismissModal,
  message,
  title,
}) => {
  return displayModal ? (
    <Modal
      isOpen={displayModal}
      onClose={isDismissable ? dismissModal : null}
      style={{ top: 0, zIndex: 10000, width: "100%", margin: "auto" }}
    >
      <WithBackground img="https://www.hrgo.co.uk/media/5314/hrgo404b.jpg">
        <div
          style={{
            position: "absolute",
            top: "40%",
            left: "50%",
            transform: "translate(-50%, -50%)",
          }}
        >
          <h2>{title || "We are sorry! There appears to be an issue."}</h2>
          <p>
            <span>
              <i className="icomoon-notification" />
            </span>
            &nbsp;{`\t${message}`}
          </p>
          <p>
            <strong>In the meantime, try heading back to your account</strong>
          </p>
          <a href="/my-account/profile">
            <div className="btn btn-primary">Back to My Account</div>
          </a>
        </div>{" "}
      </WithBackground>
    </Modal>
  ) : null;
};

ErrorModal.propTypes = {
  displayModal: bool,
  dismissErrorModal: func,
  dismissModal: func,
  message: string,
  title: string,
  isDismissable: bool,
};

const mapStateToProps = ({ core: { showErrorModal, errorMessage } }) => ({
  displayModal: showErrorModal,
  message: errorMessage,
});

const mapDispatchToProps = {
  dismissModal: dismissErrorModal,
};

const withRedux = connect(mapStateToProps, mapDispatchToProps);

export default withRedux(ErrorModal);
